import { request } from 'assets/fetchHandler';

class ProductApi {
  /**
    * 获取商品详情
    * @param params
    */
  getProductDetail(params) {
    return request({
      url: '/front/api/assembleproduct',
      params
    });
  }

  /**
   * 获取关联商品
   * @see https://confluence.hexiaoxiang.com/pages/viewpage.action?pageId=41452785
   * @param {*} params 
   * @returns 
   */
  getRelationProducts(params) {
    return request({
      url: '/front/api/assembleproduct/relation_list',
      params
    })
  }

  /**
   * 用户该商品订单信息
   * @param params
   * @returns {*}
   */
  getProductOrder(params) {
    return request({
      url: '/pay/master_order',
      params
    });
  }

  /**
  * 获取客服联系电话
  * @param params
  * @returns {*}
  */
  getCellPhone(params) {
    return request({
      url: '/front/api/staff',
      params
    });
  }

  /**
    * 获取组合商品二维码
    * @param params
    */
  getQrcodeList(params) {
    return request({
      url: '/front/api/user/staff/connect/qr_code',
      params
    });
  }
}

export default new ProductApi();